import React from "react";
import { ScrollView } from "react-native";
import { Tag } from "../ui/tag";

function TutorSubjectYearGroups({
  yearGroupIds,
  onYearGroupSelect,
  yearGroups,
}: {
  yearGroupIds: string[];
  onYearGroupSelect: (yearGroupIds: string[]) => void;
  yearGroups: { label: string; value: string }[];
}) {
  const selectedYearGroups = yearGroups.filter((yearGroup) =>
    yearGroupIds.includes(yearGroup.value)
  );

  return (
    <ScrollView horizontal contentContainerClassName="gap-4" showsHorizontalScrollIndicator={false}>
      {selectedYearGroups.map((yearGroup) => (
        <Tag
          key={yearGroup.value}
          size="md"
          className="self-start w-auto"
          close
        >
          <Tag.Text size="md">{yearGroup.label}</Tag.Text>
          <Tag.Close
            onPress={() =>
              onYearGroupSelect(
                yearGroupIds.filter((id) => id !== yearGroup.value)
              )
            }
          />
        </Tag>
      ))}
    </ScrollView>
  );
}

export default TutorSubjectYearGroups;
